// extracted by mini-css-extract-plugin
export default {"p":"List_p__sQAre","types":"List_types__LxAFE","type":"List_type__IxUqK","icon":"List_icon__Fz4qn"};